export default {
  methods: {
    validateUser(rule, value, callback) {
      // Length checks
      if (value === '') {
        return 'Please input Username'
      } else if (value.length < 3) {
        return 'Must contain at least 3 characters'
      } else if (value.length > 150) {
        return 'Can contain maximum 150 characters'
      }

      // RegEx checks (ASCIIUsernameValidator)
      // eslint-disable-next-line
      const isValidAsciiValue = /^[\x00-\x7F]*$/.test(value)

      if (!isValidAsciiValue) {
        return 'Username may contain only english letters, numbers and characters'
      }
    },
    validateFirstName(rule, value, callback) {
      // Length checks
      if (value.length > 30) {
        return 'Can contain maximum 30 characters'
      }
    },
    validateLastName(rule, value, callback) {
      // Length checks
      if (value.length > 150) {
        return 'Can contain maximum 150 characters'
      }
    },
    validatePass(rule, value, callback) {
      if (value === '') {
        return 'Please input password'
      } else if (value.length < 8) {
        return 'Must contain at least 8 characters'
      }

      // RegEx checks
      const isOnlyNumbers = /^\d+$/.test(value)
      // eslint-disable-next-line
      const isValidAsciiValue = /^[\x00-\x7F]*$/.test(value)

      if (isOnlyNumbers) {
        return 'Password cannot be entirely numeric'
      } else if (!isValidAsciiValue) {
        return 'Username may contain only english letters, numbers and characters'
      }
    },
    validateURL(rule, value, callback) {
      if (!this.validURL(value)) {
        return 'Please input valid URL'
      }
    },
    validURL: function (value) {
      const re = /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i
      return re.test(value)
    },
    validateEmail(rule, value, callback) {
      if (value === '') {
        return 'Please input Email'
      } else {
        if (!this.validEmail(value)) {
          return 'Please input a valid Email'
        }
      }
    },
    validEmail: function (email) {
      // eslint-disable-next-line
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    setHttp(url) {
      // eslint-disable-next-line
      if (url.search(/^http[s]?\:\/\//) == -1) {
        url = 'https://' + url
      }
      return url
    },
  },
}
